import React, { Fragment, useContext, useEffect, useState, Component } from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Button, Icon, Label } from "semantic-ui-react";
import errorPDF from '../../../../assets/PDFNotFound.pdf';
// Core viewer
import { Viewer } from '@react-pdf-viewer/core';
import { RenderRotateProps, RotateDirection, rotatePlugin } from '@react-pdf-viewer/rotate';
import { RenderGoToNextPageProps, RenderGoToPreviousPageProps } from '@react-pdf-viewer/page-navigation';
import { toolbarPlugin, ToolbarSlot } from '@react-pdf-viewer/toolbar';
import { RenderCurrentScaleProps, RenderZoomInProps, RenderZoomOutProps } from '@react-pdf-viewer/zoom';

// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/';

const RequestReviewPDF: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { pdf, loadPDF } = rootStore.requestReviewStore;
    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;
    const rotatePluginInstance = rotatePlugin();
    const { Rotate } = rotatePluginInstance;

    useEffect(() => {
        loadPDF(localStorage.getItem("requestId"));
    }, [loadPDF]);

    return (
        <Fragment>
            <div
                style={{
                    border: '1px solid rgba(0, 0, 0, 0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <div
                    style={{
                        alignItems: 'center',
                        backgroundColor: '#eeeeee',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        padding: '4px',
                    }}
                >
                    <Toolbar>
                        {
                            (props: ToolbarSlot) => {
                                const {
                                    CurrentPageInput, CurrentScale, GoToNextPage, GoToPreviousPage,
                                    NumberOfPages, ZoomIn, ZoomOut,
                                } = props;
                                return (
                                    <>
                                        <div style={{ padding: '0px 2px' }}>
                                            <ZoomOut>
                                                {
                                                    (props: RenderZoomOutProps) => (
                                                        <Button
                                                            onClick={props.onClick}
                                                            className={"rl-btn"}
                                                            style={{ width: "48px" }}
                                                            size={"mini"}>
                                                            <Icon size={"large"} name={"zoom-out"} />
                                                        </Button>
                                                    )
                                                }
                                            </ZoomOut>
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <CurrentScale>
                                                {
                                                    (props: RenderCurrentScaleProps) => (
                                                        <span>{`${Math.round(props.scale * 100)}%`}</span>
                                                    )
                                                }
                                            </CurrentScale>
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <ZoomIn>
                                                {
                                                    (props: RenderZoomInProps) => (
                                                        <Button
                                                            onClick={props.onClick}
                                                            className={"rl-btn"}
                                                            style={{ width: "48px" }}
                                                            size={"mini"}>
                                                            <Icon size={"large"} name={"zoom-in"} />
                                                        </Button>
                                                    )
                                                }
                                            </ZoomIn>
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <Rotate direction={RotateDirection.Backward}>
                                                {
                                                    (props: RenderRotateProps) => (
                                                        <Button
                                                            onClick={props.onClick}
                                                            className={"rl-btn"}
                                                            style={{ width: "48px" }}
                                                            size={"mini"}>
                                                            <Icon size={"large"} name={"undo"} />
                                                        </Button>
                                                    )
                                                }
                                            </Rotate>
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <Rotate direction={RotateDirection.Forward}>
                                                {
                                                    (props: RenderRotateProps) => (
                                                        <Button
                                                            onClick={props.onClick}
                                                            className={"rl-btn"}
                                                            style={{ width: "48px" }}
                                                            size={"mini"}>
                                                            <Icon size={"large"} name={"redo"} />
                                                        </Button>
                                                    )
                                                }
                                            </Rotate>
                                        </div>
                                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                            <Label size={"large"}>Request ID: {localStorage.getItem("requestCaseId")}</Label>
                                        </div>
                                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                            <GoToPreviousPage>
                                                {
                                                    (props: RenderGoToPreviousPageProps) => (
                                                        <Button
                                                            className={"rl-btn"}
                                                            disabled={props.isDisabled}
                                                            onClick={props.onClick}
                                                        >
                                                            Previous page
                                                        </Button>
                                                    )
                                                }
                                            </GoToPreviousPage>
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <CurrentPageInput /> / <NumberOfPages />
                                        </div>
                                        <div style={{ padding: '0px 2px' }}>
                                            <GoToNextPage>
                                                {
                                                    (props: RenderGoToNextPageProps) => (
                                                        <Button
                                                            className={"rl-btn"}
                                                            disabled={props.isDisabled}
                                                            onClick={props.onClick}
                                                        >
                                                            Next page
                                                        </Button>
                                                    )
                                                }
                                            </GoToNextPage>
                                        </div>
                                    </>
                                )
                            }
                        }
                    </Toolbar>
                </div>
                <div
                    style={{
                        flex: 1,
                        overflow: 'hidden',
                    }}
                >
                    <Viewer
                        fileUrl={pdf !== '' ? `data:application/pdf;base64,${pdf}` : errorPDF}
                        plugins={[
                            toolbarPluginInstance,
                            rotatePluginInstance
                        ]}
                    />
                </div>
            </div>
        </Fragment>
    )
}
export default observer(RequestReviewPDF);